import {SODeleteSimpleAttributePermission} from '../../core/simple-attribute-permission/so-delete-simple-attribute-permission';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteSimpleAttributePermission extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteSimpleAttributePermission;
}